export const SortDirection = {
    ASC: 'asc',
    DES: 'desc'
}